import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {EMPTY, from, iif, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {MarkdownFile, MarkdownLoaderService} from '../../services/markdown-loader.service';
import {Headline, MarkdownParserResult, MarkdownParserService} from '../../services/markdown-parser.service';

@Component({
  selector: 'cc-markdown-content',
  templateUrl: './markdown-content.component.html',
  styleUrls: ['./markdown-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkdownContentComponent implements OnChanges {
  @Input() markdown: MarkdownFile;
  @Output() readonly headlines = new EventEmitter<Headline[]>();

  result$: Observable<MarkdownParserResult | undefined>;

  constructor(
    private readonly markdownLoaderService: MarkdownLoaderService,
    private readonly markdownParserService: MarkdownParserService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.result$ = iif(
      () => !!this.markdown,
      from(this.markdownParserService.process(this.markdownLoaderService.files(this.markdown.key))),
      EMPTY,
    ).pipe(
      tap(result => this.headlines.next(result.headlines)),
    );
  }
}
